module.exports = __webpack_public_path__ + "img/7eb9b66.jpg";